import React from "react";
import { toast } from "react-toastify";
import GiftCardPrint from "./GiftCardPrint";

// Copy / share / print for a gift card. `card` is the GiftCard props; printing
// (also "Save as PDF" in the browser's print dialog) lives in GiftCardPrint.
export default function GiftCardActions({ code, redeemUrl, card }) {
  const copy = (text, message) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => toast.success(message)).catch(() => toast.error("Could not copy."));
    } else {
      toast.info(text);
    }
  };

  const share = () => {
    const text = `You've been given a VerySoul Experience! Your Gift Code: ${code}`;
    if (navigator.share) {
      navigator.share({ title: "A VerySoul Experience for you", text, url: redeemUrl }).catch(() => {});
    } else {
      copy(`${text}\n${redeemUrl}`, "Gift message copied. Paste it wherever you'd like to share it.");
    }
  };

  return (
    <>
    <div className="vsr-actions vsr-card-actions no-print">
      <button type="button" className="vsr-btn vsr-btn-outline" onClick={() => copy(code, "Gift Code copied.")}>
        Copy Gift Code
      </button>
      <button type="button" className="vsr-btn vsr-btn-outline" onClick={share}>
        Share Gift
      </button>
    </div>
    {card && <GiftCardPrint card={card} />}
    </>
  );
}
